module.exports = __webpack_public_path__ + "img/5-2.ab45a342.png";